import React, {PropTypes,Component}  from 'react';
import {autobind} from 'core-decorators';
import ColumnsContent from '../ColumnsContent/index.js';
import tools from "../../utils/tools";
import "./style.less"

class KeyContent extends Component{
    constructor(props,context){
        super(props,context);
    }

    formatValue(item,overallConfig){
        var formatValue=tools.formatDisplay(item.value, item.format);
        if(overallConfig.IsShowThousandsSeparator&&item.format!='P'&&item.type=='1'){
            formatValue=tools.thousandthNum(formatValue)
        }
        return formatValue;
    }

    render(){
        var _this=this;
        var {keyDatas,title,flag,overallConfig,isWarning}=this.props;
        var style;
        return (
            <div className="keyContent">
                {
                    title&&title.length>0? (
                        title.map((item,index)=>{
                            style= overallConfig.isRedWord&&item.value<0?{"color":"#bb1a12"}:{};
                            item.formatValue=_this.formatValue(item,overallConfig);
                            return  <span key={'title'+index} className="keyContent-title">
                            <span style={{'color':'#666'}}>{item.showtitle?`${item.title}`:void(0)} </span>
                            &nbsp;
                            <span style={style}>{item.formatValue}</span>
                            </span>
                        })

                ):void(0)
                }
                {
                     flag&&flag.length>0? (
                         flag.map((item,index)=>{
                            item.formatValue=_this.formatValue(item,overallConfig);
                           return  <div key={'overdue'+index} className="overdue" >
                               <div className={`${isWarning?`chanjet-icon-biaoqian-warning overdueLeft-warning`:`chanjet-icon-biaoqian overdueLeft`}`}></div>
                               <span className={`${isWarning?`span-warning`:void(0)}`}>{item.showtitle?`${item.title}`:void(0)}&nbsp;{item.formatValue}</span>
                            </div>
                         })
                    ):void(0)
                }

                <ColumnsContent simpleContent={keyDatas} overallConfig={overallConfig}/>
            </div>
        )
    }

}
export default KeyContent
